<template>
  <div id="app" :class="classObject">
      <!--头部-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed:{
    classObject(){
      let arr = ['/vote','/privacy','/terms']
      let index=arr.indexOf(this.$route.path);
      return{
        'pc-width':index==-1
      }
    }
  },
  mounted() {
    let arr = ['/vote','/privacy','/terms']
    let index=arr.indexOf(this.$route.path);
  	if (this._isMobile() && (index==-1)) {
      window.location.href = 'https://m.betta-games.com/'
  	} else {
  		return
  	}
  },
  methods: {
  	_isMobile() {
  		let flag = navigator.userAgent.match(
  			/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  		)
  		return flag;
  	}
  }
}
</script>

<style>
@import "../static/css/main.css";
@import "../static/css/style.css";
#app {
  font-family: 'SourceHanSansCN', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto;
}
.pc-width{
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue